'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import type { IIconsProps, AllIcons } from './_props';
import { SizeEnum, type SizeType } from './_size';

import useIconTheme from './themes';

function IconComponent({
  Icon,
  options,
  size = 'IconM',
  bg = false,
  fill,
  optSize,
  iconName,
  className,
  style = {},
  slot,
}: IIconsProps) {
  const { iconContainerBgClasses, iconContainerBgSizeClasses, iconSizeClasses } = useIconTheme(size, bg);

  if (!Icon && !iconName) return null;

  const resolvedIconName = iconName
    ? `${iconName}${optSize ? `_optsz${optSize}` : ''}${fill ? '_fill' : ''}`
    : undefined;

  return (
    <span
      className={twMerge({
        [iconContainerBgClasses]: bg,
        [iconContainerBgSizeClasses]: bg,
      })}
      slot={slot}
    >
      {Icon ? (
        <Icon {...options} size={iconSizeClasses} />
      ) : (
        <div
          className={twMerge(iconSizeClasses, className)}
          style={{
            mask: `url(${process.env.NEXT_PUBLIC_IMAGES_CLOUDINARY_NEW_BASE_URL}image/upload/v1/www/icons/${resolvedIconName}.svg)`,
            WebkitMask: `url(${process.env.NEXT_PUBLIC_IMAGES_CLOUDINARY_NEW_BASE_URL}image/upload/v1/www/icons/${resolvedIconName}.svg)`,
            ...style,
          }}
        />
      )}
    </span>
  );
}

export { IIconsProps, SizeEnum, type SizeType, type AllIcons };
export default IconComponent;
